import { render, staticRenderFns } from "./RelatedDocsSectionEditor.vue?vue&type=template&id=66919b80"
import script from "./RelatedDocsSectionEditor.vue?vue&type=script&lang=ts"
export * from "./RelatedDocsSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./RelatedDocsSectionEditor.vue?vue&type=style&index=0&id=66919b80&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports